module.exports = "/images/vendor/flag-icon-css/flags/1x1/cf.svg?1bc217dc2a400899db46ee10cdd913d8";